
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DetailDialog from '@/components/busi/table/detail.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import util from '@/utils/busi/util'
import { getSchoolList, schoolDetail } from '@/api/baseinformation'
import dayjs from 'dayjs'
@Component({
  name: 'school-manage',
  components: {
    SimpleTable,
    DetailDialog,
    DictSelect
  }
})
export default class SchoolManage extends Vue {
  private form = {
    schoolState: 1
  }

  private loading = !1

  private tableData = {
    list: [],
    totalCount: 0
  }

  private columns = [{
    prop: 'schoolCode',
    label: '院校代码'
  },
  {
    prop: 'schoolName',
    label: '院校名称'
  },
  {
    prop: 'businessName',
    label: '业务名称'
  },
  {
    prop: 'studyName',
    label: '学习类型'
  },
  {
    prop: 'schoolState',
    label: '状态'
  },
  {
    prop: 'createTimeStamp',
    label: '创建时间',
    format: 'date'
  }]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private async onQuery (pagination: any = null) {
    this.loading = !0
    const form = util.trimForm(this.form)
    !pagination && (this.pagination.currentPage = 1)
    await getSchoolList({
      ...form,
      ...pagination || this.pagination
    }).then((res: any) => {
      this.loading = !1
      this.tableData.list = res.object.list
      this.tableData.totalCount = res.object.totalCount
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
      schoolState: 1
    }
    this.onQuery()
  }

  private currentPage = 1

  private visible = !1

  private detailData = {}

  private async showDetail (row: any) {
    await schoolDetail({ id: row.id }).then((res: any) => {
      if (res.code === 10000) {
        this.visible = !0
        this.detailData = {
          schoolCode: res.object.schoolCode,
          schoolName: res.object.schoolName,
          businessName: res.object.businessName,
          studyName: res.object.studyName,
          schoolState: res.object.schoolState,
          createTime: res.object.createTimeStamp ? dayjs(res.object.createTimeStamp).format('YYYY-MM-DD HH:mm') : dayjs(row.createTimeStamp).format('YYYY-MM-DD HH:mm')
        }
      }
    })
  }

  mounted () {
    this.onQuery()
  }
}
